export default __webpack_public_path__ + "static/media/Service3.6eac3f78.png";